import { LicenceService } from './../../../services/licence.service';
import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigColumn, NumberColumnPipe, TooltipPositionType, TypeColumn } from '@eqproject/eqp-table';
import { TranslateService } from '@ngx-translate/core';
import { CommercialProductCategoryEnum, CompanyCommercialProductDTO } from '../../../models/commercialProduct.model';
import { DialogService } from '../../../services/dialog.service';
import { GlobalService } from '../../../services/global.service';
import { ProductsLimitationsComponent } from '../../licenses/products-limitations/products-limitations.component';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { CompanyCommercialProductService } from '../../../services/companyCommercialProduct.service';
import { CompanyDTO, CompanyListDTO } from '../../../models/company.model';
import { CompanyService } from '../../../services/company.service';

@Component({
  selector: 'app-company-products',
  templateUrl: './company-products.component.html',
  styleUrls: ['./company-products.component.scss']
})
export class CompanyProductComponent implements OnInit {

  commercialProductsColumns: Array<ConfigColumn> = new Array<ConfigColumn>();
  commercialProductsEFTDataSource: Array<CompanyCommercialProductDTO> = new Array<CompanyCommercialProductDTO>();
  commercialProductsPLUSDataSource: Array<CompanyCommercialProductDTO> = new Array<CompanyCommercialProductDTO>();

  selectedEFTProducts: Array<CompanyCommercialProductDTO> = new Array<CompanyCommercialProductDTO>();
  companyCommercialProductInfo: CompanyCommercialProductDTO = null;
  currentCompany: CompanyDTO;

  @ViewChild('externalLicenceAvailable', { static: true }) externalLicenceAvailable: TemplateRef<any>;
  @ViewChild('externalLicenceManager', { static: true }) externalLicenceManager: TemplateRef<any>;


  /**
   * ID della company per cui visualizzare i prodotti in uso.
   * Se NULL allora usa la company che si sta gestendo dalla navbar
   */
  @Input("fk_company") fk_company: number = null;

  /**
   * Se TRUE allora, per ciascun prodotto, mostra il pulsante delle limitazioni.
   * Questa funzionalità viene attivata SOLO quando si clicca il pulsante LIMITAZIONI dal report aziende
   */
  @Input("manageLimitations") manageLimitations: boolean = false;

  /**
   * Se TRUE allora abilita la selezione dei prodotti (di default = TRUE) altrimenti non mostra la colonna di selezione
   */
  @Input("enableProductSelection") enableProductSelection: boolean = true;

  /**
   * Se FALSE allora nasconde i bordi della mat card (da usare, ad esempio, quando il componente è dentro un mat-dialog)
   */
  @Input("showMatCard") showMatCard: boolean = true;


  /**
     * Evento di output scatenato quando viene premuto il tasto salva dall'elenco prodotti dell'azienda
     */
  @Output("companyProductsConfirmed") companyProductsConfirmed: EventEmitter<any> = new EventEmitter<any>();


  //#region Proprietà per gestione limitazioni prodotto

  currentProductLimitation: CompanyCommercialProductDTO = null;
  @ViewChild("dialogProductLimitation", { static: false }) dialogProductLimitation: TemplateRef<ProductsLimitationsComponent>;
  dialogProductLimitationRef: MatDialogRef<ProductsLimitationsComponent>;

  @ViewChild("dialogLicenceManagerStandard", { static: false }) dialogLicenceManagerStandard: TemplateRef<any>;
  @ViewChild("dialogLicenceManagerMyNamirial", { static: false }) dialogLicenceManagerMyNamirial: TemplateRef<any>;
  dialogLicenceManagerRef: MatDialogRef<any>;

  //#endregion
  constructor(
    public translate: TranslateService,
    private router: Router,
    private activateRoute: ActivatedRoute,
    private licenceService: LicenceService,
    private dialog: MatDialog,
    private companyCommercialProductService: CompanyCommercialProductService,
    private companyService: CompanyService) { }

    async ngOnInit() {

    //Se non è stata passata la company come input
    if (this.fk_company == null || this.fk_company == undefined || this.fk_company == 0)
    {
      this.fk_company = GlobalService.getUsedCompany();
     
    }
    

    this.configureProductsColumns();
    this.getAllCompanyProducts();

    //Se la company è diversa da quella con cui ci si è loggati
    if (this.fk_company != GlobalService.getCurrentCompany().ID)
    {
      await this.companyService.getCompanyByIDInternal(this.fk_company).then(res => {
      this.currentCompany = res;      
    })
    }
    else
    {      
      await this.companyService.getCompanyByID(this.fk_company).then(res => {
      this.currentCompany = res;      
      })    
     } 
    
    
  }

  configureProductsColumns() {
    this.commercialProductsColumns = [
      { key: "CommercialProduct.CommercialProductCategoryEnum", display: "Categoria", type: TypeColumn.Enum, enumModel: CommercialProductCategoryEnum, multilanguagePrefixKey: "ENUMS.COMMERCIAL_PRODUCT_CATEGORY.", styles: { flex: "0 0 10%" } },
      { key: "CommercialProduct.Code", display: "Codice", styles: { flex: "0 0 12%" } },
      { key: "CommercialProduct.Title", display: "Titolo" },      
      // { key: "CommercialProduct.Credits", display: "Prezzo", styles: { flex: "0 0 12%" }, numberPipe: NumberColumnPipe.CURRENCY, currencyPipeCode: "EUR" },
      { key: "LicensesManager", display: "Tipo rinnovo", type: TypeColumn.ExternalTemplate, externalTemplate: this.externalLicenceManager },
      { key: "ExpireDate", value: (element) => { return element.InUseTo ? element.InUseTo : element.CommercialProduct.EndDate }, type: TypeColumn.Date, display: "Data scadenza", styles: { flex: "0 0 15%" } },
      { key: "LicensesAvailable", display: "# Licenze", styles: { flex: "0 0 10%" }, type: TypeColumn.ExternalTemplate, externalTemplate: this.externalLicenceAvailable },
      {
        key: "InUse",
        display: this.translate.instant("GENERIC_FIELDS.IN_USE"),
        type: TypeColumn.Boolean,
        booleanValues: {
          false: '<i class="fa fa-close error-color"></i>',
          true: '<i class="fa fa-check success-color"></i>'
        },
        styles: { flex: "0 0 8%" }
      }
    ];

    if (this.manageLimitations == true) {
      this.commercialProductsColumns.push({
        key: "limitation", display: this.translate.instant("GENERIC_LABEL.LIMITATIONS"),
        type: TypeColumn.SimpleAction, styles: { flex: "0 0 8%" },
        actions: [
          {
            name: '',
            icon: "remove_circle",
            fn: (element) => this.setProductLimitations(element),
            disabled: (element) => { return !this.manageLimitations },
            tooltip: { tooltipText: this.translate.instant("GENERIC_LABEL.SET_LIMITATIONS"), tooltipPosition: TooltipPositionType.Above }
          }
        ]
      });
    }
  }

  checkAdmin(element): string {

    let licenceNumber: string;

    if (element.IsAdmin == true)
      licenceNumber = '∞';
    else
      licenceNumber = element.LicensesAvailable;

    return licenceNumber;
  }

  async getAllCompanyProducts() {

    //Recupera tutti i prodotti acquistati dalla company richiesta
    let allProducts = await this.licenceService.getCommercialProductsByCompany(this.fk_company);

    this.commercialProductsEFTDataSource = new Array<CompanyCommercialProductDTO>();
    this.commercialProductsPLUSDataSource = new Array<CompanyCommercialProductDTO>();

    //Filtra tra tutti i prodotti SOLO quelli della famiglia EFT
    this.commercialProductsEFTDataSource = allProducts.filter(p => p.CommercialProduct?.CommercialProductCategoryEnum == CommercialProductCategoryEnum.EFT)

    //Filtra tra tutti i prodotti SOLO quelli della famiglia PLUS
    this.commercialProductsPLUSDataSource = allProducts.filter(p => p.CommercialProduct?.CommercialProductCategoryEnum == CommercialProductCategoryEnum.PLUS);
  }

  save() {

    //Verifica che sia stato indicato almeno un prodotto per ciascuna categoria (da completare con PLUS quando disponibile)
    if (this.selectedEFTProducts == null || this.selectedEFTProducts.length == 0) {
      DialogService.Error(this.translate.instant("DIALOGS.PRODUCT_IN_USE_NOT_SELECTED"));
      return;
    }

    let productsSelectedForSave: Array<CompanyCommercialProductDTO> = [
      this.selectedEFTProducts[0]
    ];

    //TODO: verifica selezione su prodotto plus e aggiunta all'array productsselectedForSave

    DialogService.Confirm(this.translate.instant("DIALOGS.PRODUCT_IN_USE_CONFIRM"), () => {
      this.companyCommercialProductService.saveCompanyProducts(productsSelectedForSave)
        .then((res) => {
          DialogService.Success(this.translate.instant("DIALOGS.SAVE_SUCCESS"))
          this.selectedEFTProducts = new Array<CompanyCommercialProductDTO>();
          this.getAllCompanyProducts();
        })
        .catch((err) => {
          DialogService.Error(err.message);
        });
    });
  }

  exit() {
    if (this.companyProductsConfirmed)
      this.companyProductsConfirmed.emit();
  }

  //#region Gestione limitazioni su prodotto

  /**
   * Funzione richiamata quando viene premuto il tasto relativo alle limitazioni da impostare per un prodotto commerciale
   * @param item Item che identifica la riga di licenza per cui impostare le limitazioni
   */
  setProductLimitations(item: CompanyCommercialProductDTO) {
    this.currentProductLimitation = item;
    this.dialogProductLimitationRef = this.dialog.open(this.dialogProductLimitation, {
      disableClose: false,
      hasBackdrop: true,
      minHeight: '30%',
      minWidth: '30%'
    })
  }

  /**
   * Funzione richiamato dall'evento di output presente sul componente ProductsLimitationComponente, alla conferma dell'applicazione della limitazione sulla licenza
   * @param limitation
   */
  productsLimitationConfirmed(limitation: CompanyCommercialProductDTO) {
    if (limitation) {
      this.companyCommercialProductService.saveCompanyProducts([limitation])
        .then((res) => {
          DialogService.Success(this.translate.instant("DIALOGS.LIMITATION_UPDATED"));
          this.getAllCompanyProducts();
          this.dialogProductLimitationRef.close();
        })
        .catch((err) => {
          DialogService.Error(err.message);
        });
    }
  }

  //#endregion

  /**
   * Se è presente il MyNamirialEmail allora sto parlando di un abbonamento ricorrente e quindi faccio vedere la modale associata, altrimenti quella dei clienti standard
   * @param element CompanyCommercialProductDTO
   */
  openLicenceManagerDialog(element: CompanyCommercialProductDTO) {

    this.companyCommercialProductInfo = element;    
    this.dialogLicenceManagerRef = this.dialog.open((element != null && element.MyNamirialPurchaseEmail != null) ? this.dialogLicenceManagerMyNamirial : this.dialogLicenceManagerStandard, {    
      disableClose: false,
      hasBackdrop: true,
      minHeight: '30%',
      minWidth: '30%'
    })
  }
}


